<!--
 * @Version      : V1.0
 * @Date         : 2025-05-21 13:27:18
 * @fileName     : 
 * @Description  : 电费详情
-->
<template>
  <el-drawer :title="title" v-loading="loading" :visible.sync="dialogDrawer" direction="rtl" :wrapperClosable="false"
    size="80%" :before-close="closeDrawer">
    <div class="details px-20 py-20 border-box">
      <el-row :gutter="20">
        <el-col :span="status === 'add' ? 24 : 18">
          <add v-if="!showDesc" ref="addRef" :status="status" :row-data="rowData" @queryData="queryData"
            @success="closeDrawer"></add>
          <auditCom v-if="toExamine && dialogDrawer" @refreshInitData="childReviewer"></auditCom>
        </el-col>
        <el-col :span="6" v-if="status !== 'add'">
          <div class="approval-progress">
            <div class="progress-box" v-if="status !== 'add'">
              <div class="progress-title">审批流程</div>
              <div class="progress-desc-info flex flex-wrap">
                <el-breadcrumb separator-class="el-icon-arrow-right">
                  <el-breadcrumb-item v-for="(item, index) in processDescInfo" :key="index">
                    <div class="items">
                      <el-avatar shape="square" size="large"
                        :src="item ? imageUrlprefix + item : defaultAvatar"></el-avatar>
                    </div>
                  </el-breadcrumb-item>
                </el-breadcrumb>
              </div>
            </div>
            <div class="progress-title" v-if="status !== 'add'">审批进度</div>
            <div class="progress-con" v-if="status !== 'add'">
              <el-timeline>
                <el-timeline-item v-for="(item, index) in processList" :key="index" size="large"
                  :icon="auditProcessStatus(item.auditStatus).icon" :color="auditProcessStatus(item.auditStatus).color">
                  <el-row :gutter="15">
                    <el-col :span="6">
                      <div>
                        <el-image v-if="item.typeLabel == '抄送人'" style="width: 40px;height: 40px;"
                          :src="require('@/assets/makeACopyFor.png')" fit="cover"></el-image>
                        <el-avatar shape="square" v-else size="large"
                          :src="item.avatar ? imageUrlprefix + item.avatar : defaultAvatar"></el-avatar>
                      </div>
                    </el-col>
                    <el-col :span="18" v-if="item.typeLabel == '抄送人'">
                      <div class="makeACopyFor-desc">
                        <div class="makeACopyFor-title">
                          {{ item.typeLabel }}
                        </div>
                        <div class="makeACopyFor-num">
                          已抄送{{ item.userList ? item.userList.length : 0 }}人
                        </div>
                        <div class="makeACopyFor-box flex justify-start items-center flex-wrap">
                          <div class="child-items" v-for="(cItem, cIndex) in item.userList" :key="cIndex">
                            <el-avatar shape="square" size="large"
                              :src="cItem.userAvatar ? imageUrlprefix + cItem.userAvatar : defaultAvatar"></el-avatar>
                            <div class="child-text">{{ cItem.userName }}</div>
                          </div>
                        </div>
                      </div>
                    </el-col>
                    <el-col :span="18" v-else>
                      <div class="progress-desc">
                        <div><span>{{ item.name }}</span><span class="progress-time">{{ item.date }}</span></div>
                        <div>{{ item.typeLabel }}</div>
                        <div :style="{ color: auditProcessStatus(item.auditStatus).color, fontSize: '18px' }">{{
                          item.auditLabel }}</div>
                        <div class="signature-box flex justify-start items-center" v-if="item.signatureUrl">
                          <span class="signature-title">签名</span>
                          <el-image class="signature-img" :src="imageUrlprefix + item.signatureUrl"
                            fit="contain"></el-image>
                        </div>
                        <el-tooltip class="item" effect="dark" :content="item.auditComment" placement="top-start">
                          <p class="notes-text" v-if="item.auditStatus == 2">
                            {{ item.auditComment }}
                          </p>
                        </el-tooltip>
                      </div>
                    </el-col>
                  </el-row>
                </el-timeline-item>
              </el-timeline>
            </div>
          </div>
        </el-col>
      </el-row>
    </div>
    <!-- 电费代付表单内部已自带提交按钮，外层 footer 隐藏 -->
    <!-- <div class="details-footer px-20 py-20 border-box" v-if="status !== 'view'">
      <el-button type="primary" @click="submit()">提交</el-button>
      <el-button type="primary" @click="temporarilyStore()" v-if="status == 'add' || status == 'edit'">暂存</el-button>
      <el-button @click="clearForm()" v-if="status == 'add' || status == 'edit'">清空</el-button>
    </div> -->

    <view-other-details ref="viewProjectRef"></view-other-details>
  </el-drawer>
</template>

<script>
import descriptions from '@/components/descriptions/index.vue'
import { queryFinElectricityPaymentDetailsApi, addFinElectricityPaymentApi, editFinElectricityPaymentApi, processFinElectricityPaymentApi, reAddFinElectricityPaymentApi, queryAuditProcessDescriptionApi } from '@/api/electricityFeePay/index'
import { getContractInvoiceAndReceivedDataApi } from '@/api/paymentContract/index'
import { queryFinElectricityCollectionDetailsApi } from '@/api/electricityFeeCollection/index'
import { queryListElectricityCollectiontApi } from '@/api/electricityFeeCollection/index'
import { queryPageForLedgerListApi } from '@/api/receivableContract‌/index'
import { auditProcessStatus } from '@/utils/index'
import { dataPage } from "@/api/sys/dictData";
import auditCom from "@/components/auditCom/index.vue"
import viewOtherDetails from "@/components/viewOtherDetails/index.vue"
import add from "@/views/electricityFeePay/components/add.vue"
export default {
  components: {
    auditCom,
    descriptions,
    viewOtherDetails,
    add
  },
  props: {
    toExamine: {
      type: Boolean,
      default: false
    },
    title: {
      type: String,
      default: '开票详情'
    },
    status: {
      type: String,
      default: 'view'
    }
  },
  data() {
    return {
      defaultAvatar: 'https://cube.elemecdn.com/9/c2/f0ee8a3c7c9638a54940382568c9dpng.png',
      dialogDrawer: false,
      contractReceivePaymentId: "",
      electricityCollectionId: "",
      selectLoading: false,
      loading: false,
      customerForm: {},
      showDesc: false,
      columns: [
        { key: 'contractReceivePaymentId', label: '关联合同', span: 6, placeholder: '请选择关联合同', disabled: true, defaultValue: '', slotName: 'contractReceivePaymentSlot' },
        { key: 'electricityCollectionId', label: '电费收款', span: 6, placeholder: '请选择电费收款列表', disabled: true, defaultValue: '', slotName: 'electricityCollectionSlot' },
        { key: 'paymentName', label: '电费合同付款名称', span: 6, placeholder: '客户名称+业务描述', input: 'input', type: 'text', disabled: true, defaultValue: '' },
        {
          key: 'relatedItemsReceivePayment', height: 'auto', label: '关联项收款情况', span: 6, placeholder: '', disabled: true, input: 'table', isShowAdd: false, slotName: 'relatedItemsReceivePaymentSlot',
          columns: [
            { label: '总金额(元)', key: 'totalAmount', width: '120px', align: 'center', placeholder: '请输入阶段', input: 'input', required: true, defaultValue: "" },
            { label: '已开票金额(元)', key: 'invoicedAmount', width: '120px', placeholder: '请输入预计金额', align: 'center', input: 'input', defaultValue: "" },
            { label: '未开票金额(元)', key: 'noInvoicedAmount', width: '120px', placeholder: '请输入预计日期', align: 'center', input: 'date', defaultValue: "" },
            { label: '已收款金额(元)', key: 'receivedAmount', width: '120px', align: 'center', placeholder: '请输入备注', input: 'input', defaultValue: "" },
            { label: '未收款金额(元)', key: 'noReceivedAmount', width: '120px', align: 'center', placeholder: '请输入备注', input: 'input', defaultValue: "" },
          ],
          defaultValue: []
        },
        // { key: 'projectTypeCode', label: '项目类型', span: 2, placeholder: '请选择项目类型', input: 'select', type: 'text', disabled: true, defaultValue: '', option: [], labelKey: 'dictLabel', valueKey: 'dictValue' },
        { key: 'buildingInformation', label: '楼盘信息', span: 3, placeholder: '请输入楼盘信息', input: 'input', type: 'text', disabled: true, defaultValue: '' },
        { key: 'computerRoomInformation', label: '机房信息', span: 3, placeholder: '请输入机房信息', input: 'input', type: 'text', disabled: true, defaultValue: '' },
        // { key: 'electricityMeterLocation', label: '电表位置', span: 6, placeholder: '请输入电表位置', input: 'input', type: 'text', disabled: true, defaultValue: '' },
        // { key: 'electricityMeterNo', label: '电表号', span: 3, placeholder: '请输入电表号', input: 'input', type: 'text', disabled: true, defaultValue: '' },
        { key: 'meterReadDate', label: '抄表日期', span: 6, placeholder: '请选择抄表日期', input: 'date', type: '', disabled: true, defaultValue: '' },

        { key: 'electricityConsumption', label: '用电量', span: 2, placeholder: '请输入用电量', input: 'input-number', type: 'text', disabled: true, defaultValue: '' },
        { key: 'originalPrice', label: '原价(元)', span: 2, placeholder: '请输入原价', input: 'input-number', type: 'text', disabled: true, defaultValue: '' },
        { key: 'chargingPrice', label: '收取价(元)', span: 2, placeholder: '请输入收取价', input: 'input-number', type: 'text', disabled: true, defaultValue: '' },

        { key: 'originalPriceTotal', label: '原价总金额(元)', span: 3, placeholder: '请输入原件总金额', input: 'input-number', type: 'text', disabled: true, defaultValue: '', amountCn: true, amountKeyName: 'originalPriceTotalCn' },
        { key: 'originalPriceTotalCn', label: '原价总金额大写', span: 3, placeholder: '请输入原件总金额大写', input: 'input', type: 'text', disabled: true, defaultValue: '' },//用电*原价
        { key: 'chargingPriceTotal', label: '收取价总金额(元)', span: 3, placeholder: '请输入收取价总金额', input: 'input-number', type: 'text', disabled: true, defaultValue: '', amountCn: true, amountKeyName: 'chargingPriceTotalCn' },
        { key: 'chargingPriceTotalCn', label: '收取价总金额大写', span: 3, placeholder: '请输入收取价总金额大写', input: 'input', type: 'text', disabled: true, defaultValue: '' },//用电*收取价
        { key: 'profit', label: '利润(元)', span: 3, placeholder: '请输入利润', input: 'input-number', type: 'text', disabled: true, defaultValue: '', amountCn: true, amountKeyName: 'profitCn' },
        { key: 'profitCn', label: '利润大写', span: 3, placeholder: '请输入利润大写', input: 'input', type: 'text', disabled: true, defaultValue: '' },

        // { key: 'lastIssueBaseNum', label: '上期表低数', span: 3, placeholder: '请输入上期表府数', input: 'input', type: 'text', disabled: true, defaultValue: '' },
        // { key: 'currentIssueBaseNum', label: '本期表底数', span: 3, placeholder: '请输入本期表底数', input: 'input', type: 'text', disabled: true, defaultValue: '' },
        {
          key: 'paymentItemList', height: 'auto', label: '收取明细', span: 6, placeholder: '', disabled: true, input: 'table', isShowAdd: false,
          columns: [
            { label: '电表位置', key: 'electricityMeterLocation', width: '120px', align: 'center', placeholder: '请输入电表位置', input: 'input', required: true, defaultValue: "", required: true, },
            { label: '电表号', key: 'electricityMeterNo', width: '120px', placeholder: '请输入电表号', align: 'center', input: 'input', defaultValue: "" },
            { label: '上期表底数', key: 'lastIssueBaseNum', width: '120px', placeholder: '请输入上期表底数', align: 'center', input: 'input', defaultValue: "" },
            { label: '本期表底数', key: 'currentIssueBaseNum', width: '120px', align: 'center', placeholder: '请输入本期表底数', input: 'input', defaultValue: "" },
          ],
          defaultValue: []
        },
        { key: 'originalPriceTotal', label: '付款总金额(元)', span: 6, placeholder: '请输入原件总金额', input: 'input-number', type: 'text', disabled: true, defaultValue: '', amountCn: true, amountKeyName: 'originalPriceTotalCn' },
        { key: 'attachment', height: '450px', label: '附件', span: 6, placeholder: '请上传附件上传', uploadType: 'project', input: 'upload', fileMaxSize: 20, disabled: true, defaultValue: [], accept: '.xls,.xlsx,.pdf,.doc,.docx,.txt,.bmp,.jpg,.jpeg,.png,.tif,.gif,.svg,.webp,.zip,.rar,.7z', limit: 50, },
        { key: 'notes', label: '备注', span: 6, placeholder: '请输入备注', input: 'textarea', type: 'textarea', disabled: true, defaultValue: '' },
      ],
      rowData: {},
      cloneColumns: [],//复制一遍
      rules: {
        contractReceivePaymentId: [],
        electricityCollectionId: [],
        paymentName: [
          { required: true, message: '请输入电费合同收款名称', trigger: 'blur' }
        ],
        computerRoomInformation: [
          { required: true, message: '请输入机房信息', trigger: 'blur' }
        ],
        buildingInformation: [
          { required: true, message: '请输入楼盘信息', trigger: 'blur' }
        ],
        electricityMeterLocation: [
          { required: true, message: '请输入电表位置', trigger: 'blur' }
        ],
        electricityConsumption: [
          { required: true, message: '请输入用电量', trigger: 'blur' }
        ],
        electricityMeterNo: [
          { required: true, message: '请输入电表号', trigger: 'blur' }
        ],
        // projectTypeCode: [
        //   { required: true, message: '请选择项目类型', trigger: 'blur' }
        // ],
        chargingPriceTotal: [
          { required: true, message: '收取价总金额', trigger: 'blur' }
        ],
        originalPriceTotal: [
          { required: true, message: '原价总金额', trigger: 'blur' }
        ],
        chargingPrice: [
          { required: true, message: '收取价', trigger: 'blur' }
        ],
        originalPrice: [
          { required: true, message: '原价', trigger: 'blur' }
        ],
        profit: [
          { required: true, message: '请选择利润', trigger: 'blur' }
        ]
      },
      processList: [],
      processDescInfo: [],
      receivableContractOption: [],
      noPayOption: [],
      relatedItemsReceivePaymentList: []
    }
  },
  mounted() {
    this.dictOption('project_type');

    this.getLedgerContractList();
    this.getNoPaymentList();
    this.cloneColumns = JSON.parse(JSON.stringify(this.columns))

  },
  methods: {
    auditProcessStatus,
    //核心方法 判断是否是新增 还是编辑  
    async openDrawer(row) {
      this.dialogDrawer = true;
      this.$nextTick(() => {
        switch (this.status) {
          case 'view':
            this.queryDetails({ id: row.id })
            break;
          case 'add':
            //新增把原有的数据设置默认值
            this.showDesc = true;
            
            if (this.columns[this.columns.length - 3].key == 'ifUploadInvoice') {
              this.columns.splice(this.columns.length - 3, 3);
            }
            for (let i = 0; i < this.columns.length; i++) {
              this.columns[i].disabled = false;
              this.columns[i].defaultValue = this.cloneColumns[i].defaultValue;
            }
            this.$nextTick(() => {
              this.showDesc = false;
            })
            this.rowData = Object.assign({}, {});
            // this.reverseDisplayList({}, 'contractReceivePaymentId')
            break;
          case 'edit':
            this.queryDetails({ id: row.id })
            break;
          case 'change':
            this.queryDetails({ id: row.id })
            break;
          case 'reAdd':
            this.queryDetails({ id: row.id })
            break;
          default:
            break;
        }
      })
    },
    //关闭弹框
    closeDrawer() {
      this.dialogDrawer = false;
      this.contractReceivePaymentId = "";
      this.electricityCollectionId = "";
      this.relatedItemsReceivePaymentList = [];
      if (this.$refs.addRef && this.$refs.addRef.clearForm) {
        this.$refs.addRef.clearForm()
      }
    },
    //详情查询
    queryDetails(params) {
      this.loading = true;
      this.showDesc = true;
      queryFinElectricityPaymentDetailsApi(params).then(res => {
        this.loading = false;
        this.showDesc = false;
        if (res.code == 200) {
          this.rowData = res.data;
          if (this.status !== 'add') {
            if (res.data.ifUploadInvoice == 1 && this.columns[this.columns.length - 3].key !== 'ifUploadInvoice') {
              this.columns.splice(this.columns.length, 0,
                {
                  key: 'ifUploadInvoice', label: '是否上传发票', span: 3, placeholder: '请选择是否上传发票', input: 'radio', type: '', disabled: true, defaultValue: '', option: [
                    { label: '是', value: 1 },
                    { label: '否', value: 0 },
                  ]
                },
                { key: 'uploadInvoiceTime', label: '上传发票时间', span: 3, placeholder: '请选择上传发票时间', input: 'date', type: '', disabled: true, defaultValue: '' },
                { key: 'uploadInvoiceUrl', height: '450px', label: '发票上传', span: 6, placeholder: '请上传发票', uploadType: 'project', input: 'upload', fileMaxSize: 20, disabled: true, defaultValue: [], accept: '.xls,.xlsx,.pdf,.doc,.docx,.txt,.bmp,.jpg,.jpeg,.png,.tif,.gif,.svg,.webp,.zip,.rar,.7z', limit: 50, },
              )
            }
            this.electricityCollectionId = res.data.electricityCollectionId;
            this.contractReceivePaymentId = res.data.contractReceivePaymentId;
            for (let i = 0; i < this.columns.length; i++) {
              this.columns[i].disabled = this.status == 'view' ? true : false;
              if (['ifUploadInvoice', 'uploadInvoiceTime', 'uploadInvoiceUrl'].includes(this.columns[i].key)) {
                this.columns[i].disabled = true;
              }
              if (this.columns[i].key == 'relatedItemsReceivePayment') {
                this.reverseDisplayList({ id: res.data.contractReceivePaymentId }, 'contractReceivePaymentId')
              } else {
                this.columns[i].defaultValue = this.rowData[this.columns[i].key];
              }

            }
          }


        }
      }).catch(err => {
        this.loading = false;
      })
      this.queryProcessProject(params)
      this.qeuryAuditProcessDescription(params)
    },
    //提交
    submit(status = 1) {
      this.$refs.descriptionsRef.submit().then((formData = {}) => {
        if ('relatedItemsReceivePayment' in formData) {
          delete formData.relatedItemsReceivePayment
        }
        let params = {
          paymentStatus: status,
          ...formData,
          contractReceivePaymentId: this.contractReceivePaymentId,
          electricityCollectionId: this.electricityCollectionId
        }
        this.loading = true;
        if (this.status == 'add') {
          addFinElectricityPaymentApi(params).then(res => {
            if (res.code == 200) {
              this.$message({
                message: res.msg,
                type: 'success'
              });
            } else {
              this.$message({
                message: res.msg,
                type: 'warning'
              });
            }
            this.loading = false;
            this.closeDrawer();
            this.queryData();
          }).catch(err => {
            this.loading = false;
          })
        } else if (this.status == 'reAdd') {
          reAddFinElectricityPaymentApi(params).then(res => {
            if (res.code == 200) {
              this.$message({
                message: res.msg,
                type: 'success'
              });
            } else {
              this.$message({
                message: res.msg,
                type: 'warning'
              });
            }
            this.loading = false;
            this.closeDrawer();
            this.queryData();
          }).catch(err => {
            this.loading = false;
          })
        } else {
          editFinElectricityPaymentApi(params).then(res => {
            if (res.code == 200) {
              this.$message({
                message: res.msg,
                type: 'success'
              });
            }
            this.loading = false;
            this.closeDrawer();
            this.queryData();
          }).catch(err => {
            this.loading = false;
          })
        }

      })
    },
    //暂存
    temporarilyStore() {
      if (this.$refs.addRef && this.$refs.addRef.submit) {
        this.$refs.addRef.submit(0)
        return
      }
      this.submit(0);
    },
    //清空描述组件form
    clearForm() {
      if (this.$refs.addRef && this.$refs.addRef.clearForm) {
        this.$refs.addRef.clearForm()
        return
      }
      this.$refs.descriptionsRef.resetForm()
    },
    //查询列表
    queryData() {
      this.$emit('initQueryData')
    },
    async dictOption(type) {
      let params = {
        query: {
          dictType: type
        }
      }
      dataPage(params).then(res => {
        if (res.code == 200) {
          this.columns.map(item => {
            if (item.key == 'projectTypeCode' && type == 'project_type') {
              item.option = res.data.rows || []
            }
            return item
          })
        }
      })
    },
    //查询收款合同台账
    getLedgerContractList(v = '') {
      let params = {
        params: {
          contractName: v,
        }
      }
      this.selectLoading = true;
      queryPageForLedgerListApi(params).then(res => {
        this.selectLoading = false;
        if (res.code == 200) {
          this.receivableContractOption = res.data;
        }
      })
    },
    //查询电费收款列表
    getNoPaymentList(v = '') {
      let params = {
        params: {
          name: v,
        },
        contractReceivePaymentId: this.contractReceivePaymentId
      }
      this.selectLoading = true;
      queryListElectricityCollectiontApi(params).then(res => {
        this.selectLoading = false;
        if (res.code == 200) {
          this.noPayOption = res.data;
        }
      })
    },
    // 通过合同-获取开票和收款数据
    getInvoiceAndReceivedDataContract(id) {
      let params = {
        id,
      }
      getContractInvoiceAndReceivedDataApi(params).then(res => {
        if (res.code == 200) {
          this.relatedItemsReceivePaymentList = res.data ? [res.data] : [] || [];

        }
      })
    },
    remoteMethod(query, current = '') {
      if (query !== '') {
        this.getNoPaymentList()
      } else {
        this.receivableContractOption = [];
        this.noPayOption = [];
      }
    },
    //审批进度
    queryProcessProject(params) {
      processFinElectricityPaymentApi(params).then(res => {
        if (res.code == 200) {
          this.processList = res.data;
        }
      })
    },
    qeuryAuditProcessDescription(params) {
      queryAuditProcessDescriptionApi(params).then(res => {
        if (res.code == 200) {
          this.processDescInfo = res.data.avatars;
        }
      })
    },
    //下拉当前选中
    curOption(v = {}, slotData, current) {
      let item = v;
      if (current == 'contractReceivePaymentId') {
        this.reverseDisplayList(v, current)
      } else {
        if ((this.status == 'add' || this.status == 'edit' || this.status == 'change' || this.status == 'reAdd')) {
          queryFinElectricityCollectionDetailsApi({id:item.id}).then(res=>{
            if(res.code==200){
              for (let i = 0; i < this.columns.length; i++) {
                if(this.columns[i].key == "paymentItemList"){
                  this.columns[i].defaultValue = res.data.collectionItemList;
                }
                for (let key in res.data) {
                  if (this.columns[i].key == key && !this.columns[i].slotName) {
                    this.columns[i].disabled = false;
                    if (['ifUploadInvoice', 'uploadInvoiceTime', 'uploadInvoiceUrl'].includes(this.columns[i].key)) {
                      this.columns[i].disabled = true;
                    }
                    if(this.columns[i].key!=='attachment'&&this.columns[i].key!=='notes'){
                      this.columns[i].defaultValue = res.data[this.columns[i].key];
                    }
                     
                  }
                }
              }
            }
          })
          
        }
      }
    },
    //关联电费收款情况反显
    reverseDisplayList(data = {}, current) {

      if (current) {
        if (current == 'contractReceivePaymentId' && data.hasOwnProperty('id')) {
          this.getInvoiceAndReceivedDataContract(data.id)
        } else {
          this.columns.map(item => {
            if (item.key == 'relatedItemsReceivePayment') {
              item.defaultValue = [
                {
                  totalAmount: '--',
                  noInvoicedAmount: '--',
                  noReceivedAmount: '--',
                  receivedAmount: '--',
                  invoicedAmount: '--'
                }
              ]
            }
            return item
          })
        }
      }
    },
    //关闭详情 刷新页面
    childReviewer(row) {
      this.closeDrawer()
      this.$emit('parReviewer')
    },
    openViewProject(id, correlationType) {
      this.$refs.viewProjectRef.viewProject(id, correlationType)
    }
  }
}
</script>

<style scoped lang="scss">
.details-footer {
  height: 50px;
  line-height: 50px;
  text-align: right;
}

.progress-box {
  padding: 5px;
  box-sizing: border-box;
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, .1);
  border-radius: 5px;
  margin-bottom: 5px;
  background: #285af1;

  .progress-title {
    font-size: 18px;
    padding-bottom: 10px;
    color: #fff;
  }

  .progress-desc-info {
    padding: 10px 0px 10px 0px;

    .items {
      font-size: 15px;
      display: inline-block;
      vertical-align: middle;
    }
  }
}

.approval-progress {


  .progress-title {
    font-size: 18px;
    padding-bottom: 10px;
  }

  .progress-con {
    .progress-desc {
      line-height: 20px;
      color: #303133;

      .progress-time {
        margin-left: 10px;
        color: #909399;
      }

      .notes-text {
        display: -webkit-box;
        /* 设置为弹性盒子模型 */
        -webkit-box-orient: vertical;
        /* 垂直排列 */
        -webkit-line-clamp: 2;
        /* 显示最多 3 行 */
        overflow: hidden;
        /* 隐藏超出的部分 */
        text-overflow: ellipsis;
        /* 使用省略号 */
      }

      .signature-box {
        width: 180px;
        height: 50px;
        overflow: hidden;

        .signature-title {
          display: block;
          width: 40px;
        }

        .signature-img {
          margin-left: 10px;
          width: 180px;
        }
      }
    }

    .makeACopyFor-desc {
      line-height: 20px;
      color: #303133;

      .makeACopyFor-title {}

      .makeACopyFor-num {
        color: #909399;
      }

      .makeACopyFor-box {
        .child-items {
          padding-right: 5px;
          box-sizing: border-box;

          .child-text {
            text-align: center;
          }
        }
      }
    }
  }
}

::v-deep .el-drawer__header {
  color: #000;
  font-size: 18px;
}

::v-deep .el-breadcrumb__separator {
  color: #fff;
}
</style>